import FJTextBasedEditingRight from '../view/FJTextBasedEditingRight';
import { useSelector } from 'react-redux';

const FJTextBasedEditingRightContainer = () => {
    const sourceType = useSelector(state => state.rightTextBaseEditing.sourceType);
    const isBlank = useSelector(state => state.rightTextBaseEditing.isBlank);

    return <FJTextBasedEditingRight sourceType={sourceType} isBlank={isBlank} />;
};

export default FJTextBasedEditingRightContainer;
